import React, { createContext, useContext, useState } from 'react';

interface HistoryOverrideContextType {
  overrideResults: any[] | null;
  setOverrideResults: (results: any[] | null) => void;
  overrideHash: string | null;
  setOverrideHash: (hash: string | null) => void;
  overrideTitle: string | null;
  setOverrideTitle: (title: string | null) => void;
  isLoading: boolean;
  setIsLoading: (v: boolean) => void;
}

const HistoryOverrideContext = createContext<HistoryOverrideContextType>({
  overrideResults: null,
  setOverrideResults: () => {},
  overrideHash: null,
  setOverrideHash: () => {},
  overrideTitle: null,
  setOverrideTitle: () => {},
  isLoading: false,
  setIsLoading: () => {},
});

export const HistoryOverrideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [overrideResults, setOverrideResults] = useState<any[] | null>(null);
  const [overrideHash, setOverrideHash] = useState<string | null>(null);
  const [overrideTitle, setOverrideTitle] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <HistoryOverrideContext.Provider value={{
      overrideResults, setOverrideResults,
      overrideHash, setOverrideHash,
      overrideTitle, setOverrideTitle,
      isLoading, setIsLoading,
    }}>
      {children}
    </HistoryOverrideContext.Provider>
  );
};

export const useHistoryOverride = () => useContext(HistoryOverrideContext);